import React from 'react';
import { useIntl } from 'react-intl';

import { EMAIL_LINKS } from '../../../constants';
import { FieldInput } from '../../ui';
import { DescriptionLink, FieldWrapper, ProviderSubtitle, ProviderTitle } from '../style';
import { ProviderFieldsProps } from './types';
import { maxSendGridKeyLength } from './validator';

export const SendGridFields = ({ errors }: ProviderFieldsProps): JSX.Element => {
  const intl = useIntl();

  const getError = (): string => {
    if (errors.provider_settings && errors.sendgrid_api_key) {
      return intl.formatMessage(
        { id: errors.sendgrid_api_key },
        {
          number: maxSendGridKeyLength
        }
      );
    }

    return '';
  };

  return (
    <>
      <ProviderTitle>
        {intl.formatMessage({ id: 'custom-providers.settings.email.provider.send-grid.label' })}
      </ProviderTitle>
      <ProviderSubtitle>
        {intl.formatMessage(
          { id: 'custom-providers.settings.email.provider.send-grid.description' },
          {
            a: (chunk: string) => (
              <DescriptionLink href={EMAIL_LINKS.SENDGRID_API_KEY} target="_blank">
                {chunk}
              </DescriptionLink>
            )
          }
        )}
      </ProviderSubtitle>
      <FieldWrapper>
        <FieldInput
          label={intl.formatMessage({
            id: 'custom-providers.settings.email.provider.send-grid.api-key.label'
          })}
          placeholder={intl.formatMessage({
            id: 'custom-providers.settings.email.provider.send-grid.api-key.placeholder'
          })}
          name="provider_settings.sendgrid_api_key"
          errorMessage={getError()}
        />
      </FieldWrapper>
    </>
  );
};
